export const routesConfig = [
    {
        label: "Dashboard",
        icon: "pi pi-th-large",
        path: "/dashboard"
    },
    {
        label: "Vault Access",
        children: [
            { label: "Live Inventory", path: "/LiveInventory" },
            { label: "Cart", path: "/cart" },
            { label: "Enquiries", path: "/enquiry" }
        ]
    },
    {
        label: "Vault Style",
        children: [
            { label: "Style Inventory", path: "/StyleInventory" },
            { label: "Style Cart", path: "/StyleCart" },
            { label: "Wishlist", path: "/Wishlist" },
            { label: "Orders", path: "/order" }
        ]
    },
    {
        label: "Stock Reports",
        icon: "pi pi-chart-line",
        path: "/report"
    },
    //{
    //    label: "Change Password",
    //    icon: "pi pi-lock",
    //    path: "/changepassword"
    //},
    //FOR SUBMENU 
    //{
    //    label: "Stock Reports",
    //    icon: "pi pi-chart-line",
    //    children: [
    //        { label: "Default", path: "/reports" }
    //    ]
    //},
];